import {cn} from '@/lib/utils';

/** Внешние стоковые заглушки не показываем: вместо них рисуем монограмму студии. */
export function isPlaceholderImage(url: string | null | undefined): boolean {
  return !url || /picsum\.photos|placehold|dummyimage|lorempixel/i.test(url);
}

function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const letters = words.length > 1 ? words.slice(0, 2).map((w) => w[0]) : [...(words[0] ?? '?')].slice(0, 2);
  return letters.join('').toUpperCase();
}

export function TenantLogo({
  name,
  logoUrl,
  className,
}: {
  name: string;
  logoUrl?: string | null;
  className?: string;
}) {
  if (!isPlaceholderImage(logoUrl)) {
    return <img src={logoUrl ?? ''} alt="" className={cn('logo-glow rounded-lg object-cover', className)} />;
  }
  return (
    <span
      aria-hidden
      className={cn(
        'flex items-center justify-center rounded-lg border border-white/15 bg-white/5 font-bold text-foreground',
        className,
      )}
      style={{fontSize: '0.72em'}}
    >
      {initials(name)}
    </span>
  );
}
